import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  message: 'Hello'
}

export default {
  state,
  actions,
  getters,
  mutations
}
